import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text, Stack, Center } from '@mantine/core';
import './EmptyState.css';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  action,
  size = 'md'
}) => {
  const { t } = useTranslation();

  const sizeStyles = {
    sm: {
      titleSize: 'md',
      descriptionSize: 'sm',
      iconSize: 32,
      padding: '2rem'
    },
    md: {
      titleSize: 'lg',
      descriptionSize: 'sm',
      iconSize: 48,
      padding: '3rem'
    },
    lg: {
      titleSize: 'xl',
      descriptionSize: 'md',
      iconSize: 64,
      padding: '4rem'
    }
  };

  const styles = sizeStyles[size];

  return (
    <Center className={`empty-state-center empty-state--${size}`}>
      <Stack align="center" gap="md" maw={400}>
        {icon && (
          <Box className="empty-state-icon">
            {icon}
          </Box>
        )}
        
        <Text 
          size={styles.titleSize} 
          fw={600} 
          ta="center" 
          c="dimmed"
        >
          {title}
        </Text>
        
        {description && (
          <Text 
            size={styles.descriptionSize} 
            ta="center" 
            c="dimmed"
          >
            {description}
          </Text>
        )}
        
        {action && (
          <Box>
            {action}
          </Box>
        )}
      </Stack>
    </Center>
  );
};
